<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.isOnsale" @tab-click="handleFilter">
          <el-tab-pane label="出售中的商品" name="1" />
          <el-tab-pane label="仓库中的商品" name="0" />
        </el-tabs>

        <el-row :gutter="10" class="filter-container">
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.goodsName" class="filter-item" placeholder="商品名称" />
          </el-col>
          <el-col :xs="24" :sm="15">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button class="filter-item" type="success" plain icon="el-icon-document-copy" @click="openCopy">导入特权礼包</el-button>
            <el-button class="filter-item" type="danger" icon="el-icon-plus" @click="handleCreate">上架商品</el-button>
          </el-col>
        </el-row>
      </template>

      <data-table :list="list" :page-index="queryParams.page" :limit="queryParams.limit" mall="welfare" @edit="handleEdit" @delete="handleRemove" />
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>

    <el-dialog title="选择特权礼包" :visible.sync="dialogVisible" top="5vh" width="80%">
      <gift-table :id-list.sync="copyIds" show-check :show-other="false" />
      <template slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCopy">确定复制</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsList, deleteGoods, copyGiftPackage } from '@/api/goods'
import Pagination from '@/components/Pagination'
import GiftTable from '../components/GiftTable'
import DataTable from '../components/dataTable'

export default {
  name: 'WelfareList',
  components: { Pagination, GiftTable, DataTable },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryParams: {
        referred: 'backend',
        mallType: '3', // 福利商城
        goodsName: undefined,
        isOnsale: '1',
        page: 1,
        limit: 20
      },
      dialogVisible: false,
      copyIds: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getGoodsList(this.queryParams).then(response => {
        // console.log(response)
        this.list = response.records
        this.total = response.total
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setTimeout(() => { this.loading = false }, 500)
      })
    },
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    openCopy() {
      this.copyIds = []
      this.dialogVisible = true
    },
    handleCopy() {
      if (this.copyIds && this.copyIds.length) {
        this.loading = true
        copyGiftPackage(this.copyIds).then(response => {
          this.$message.success('导入成功')
          this.list = response
          setTimeout(() => {
            this.copyIds = []
            this.loading = false
            this.dialogVisible = false
          }, 500)
        }).catch(err => {
          console.error(err)
          this.loading = false
        })
      } else {
        this.$message.warning('请选择需要导入的商品')
      }
    },
    handleCreate() {
      this.$router.push({ path: '/goods/welfare/create', query: { from: 'list' }})
    },
    handleEdit(evt) {
      this.$router.push({ path: `/goods/welfare/edit`, query: { from: 'list', id: `${evt.value}` }})
    },
    handleRemove(evt) {
      this.loading = true
      if (this.queryParams.page * this.queryParams.limit >= this.total) {
        this.queryParams = Object.assign({}, this.queryParams, { page: 1 })
      }

      const params = Object.assign({}, this.queryParams, { id: evt.value })
      deleteGoods(params).then(response => {
        this.list = response.records
        this.total = response.total
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setTimeout(() => { this.loading = false }, 500)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  + .flex-tag {
    margin-top: 5px;
  }
}
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
}
</style>
